import { createSlice } from "@reduxjs/toolkit"

const initialStateResultadoGrillaPagoSinFactura= {
  dataGrillaFactura: []
}; 

export const resultadoGrillaPagosSinFacturaSlice = createSlice({ 
  name: "resultadoGrillaPagosSinFactura", 
  initialState: initialStateResultadoGrillaPagoSinFactura, 
  reducers:{
    setResultadoGrilla: (state, action)=>{
      state.dataGrillaFactura=action.payload
    },
    resetResultadoGrilla: (state) => {
      state.dataGrillaFactura=initialStateResultadoGrillaPagoSinFactura.dataGrillaFactura
    }
  }
});

export const {resetResultadoGrilla, setResultadoGrilla} = resultadoGrillaPagosSinFacturaSlice.actions
export default resultadoGrillaPagosSinFacturaSlice.reducer
